var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tool-page"
  }, [_c('Introduce', {
    attrs: {
      "title": _vm.$t('tools.cp-widgets.title'),
      "titleBefore": _vm.$t('tools.cp-widgets.title-sm1'),
      "titleSm": _vm.$t('tools.cp-widgets.title-sm2'),
      "content": _vm.$t('tools.cp-widgets.content'),
      "listFeature": _vm.listFeature
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function () {
        return [_c('b-button', {
          staticClass: "custom-btn",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function ($event) {
              return _vm.goToLogin();
            }
          }
        }, [_c('div', {
          staticClass: "text-white-button button-large text-nowrap d-flex justify-content-center"
        }, [_vm._v(" " + _vm._s(_vm.$t("tools.economic-calendar.start-btn")) + " ")])])];
      },
      proxy: true
    }, {
      key: "itemRight",
      fn: function () {
        return [_c('div', {
          staticClass: "layout-right"
        }, [_c('img', {
          staticClass: "img1",
          attrs: {
            "src": require("@/assets/toolImg/widgets1.png"),
            "alt": ""
          }
        })])];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "title title-tool-page"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.begin1")) + " "), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.begin2")) + " ")])]), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "content-item__info"
  }, [_c('div', {
    staticClass: "content-item__info__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-title1")) + " ")]), _c('div', {
    staticClass: "content-item__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text1")) + " "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text2")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text3")) + " "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text4")) + " ")])])]), _c('img', {
    attrs: {
      "src": require("@/assets/toolImg/widgets2.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content-item"
  }, [_c('img', {
    staticClass: "hinde-md",
    attrs: {
      "src": require("@/assets/toolImg/widgets3.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "content-item__info"
  }, [_c('div', {
    staticClass: "content-item__info__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-title2")) + " ")]), _c('div', {
    staticClass: "content-item__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text5")) + " ")])]), _c('img', {
    staticClass: "hinde-sm",
    attrs: {
      "src": require("@/assets/toolImg/widgets3.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "content-item__info"
  }, [_c('div', {
    staticClass: "content-item__info__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-title3")) + " ")]), _c('div', {
    staticClass: "content-item__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text6")) + " "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text7")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text8")) + " "), _c('div', {
    staticClass: "hinde-sm enter-paragraphs"
  }), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text9")) + " ")])]), _c('img', {
    attrs: {
      "src": require("@/assets/toolImg/widgets4.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content-item-full"
  }, [_c('div', {
    staticClass: "content-item-full__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-title4")) + " ")]), _c('img', {
    staticClass: "hinde-md img-full",
    attrs: {
      "src": require("@/assets/toolImg/widgets5.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "content-item-full__info"
  }, [_c('div', {
    staticClass: "content-item-full__info__text"
  }, [_c('div', {
    staticClass: "bold-all"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text10")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text11")) + " ")]), _c('div', {
    staticClass: "content-item-full__info__text"
  }, [_c('div', {
    staticClass: "bold-all"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text12")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text13")) + " ")])]), _c('div', {
    staticClass: "content-item-full__info"
  }, [_c('div', {
    staticClass: "content-item-full__info__text"
  }, [_c('div', {
    staticClass: "bold-all"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text14")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text15")) + " ")]), _c('div', {
    staticClass: "content-item-full__info__text"
  }, [_c('div', {
    staticClass: "bold-all"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text16")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text17")) + " ")])]), _c('img', {
    staticClass: "hinde-sm",
    attrs: {
      "src": require("@/assets/toolImg/widgets5.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "content-item__info"
  }, [_c('div', {
    staticClass: "content-item__info__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-title5")) + " ")]), _c('div', {
    staticClass: "content-item__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text18")) + " "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text19")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text20")) + " "), _c('div', {
    staticClass: "hinde-sm enter-paragraphs"
  }), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text21")) + " ")])]), _c('img', {
    attrs: {
      "src": require("@/assets/toolImg/widgets6.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content-item-full"
  }, [_c('div', {
    staticClass: "content-item-full__info"
  }, [_c('div', [_c('img', {
    staticClass: "hinde-md",
    attrs: {
      "src": require("@/assets/toolImg/widgets7.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "content-item-full__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-title6")) + " ")]), _c('div', {
    staticClass: "content-item-full__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text22")) + " ")]), _c('img', {
    staticClass: "hinde-sm",
    attrs: {
      "src": require("@/assets/toolImg/widgets7.png"),
      "alt": ""
    }
  })]), _c('div', [_c('img', {
    staticClass: "hinde-md",
    attrs: {
      "src": require("@/assets/toolImg/widgets8.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "content-item-full__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-title7")) + " ")]), _c('div', {
    staticClass: "content-item-full__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text23")) + " "), _c('div', {
    staticClass: "hinde-sm enter-paragraphs"
  }), _vm._v(" " + _vm._s(_vm.$t("tools.cp-widgets.content-item-text24")) + " ")]), _c('img', {
    staticClass: "hinde-sm",
    attrs: {
      "src": require("@/assets/toolImg/widgets8.png"),
      "alt": ""
    }
  })])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }